import { ref } from 'vue'

// Set to true by handheld_main.ts once router.isReady() has settled and
// Vue has painted the correct route. Gates all shell content in HandheldApp.
export const isShellReady = ref(false)
